import { useQuery } from 'react-query'
import { API } from 'core/requests'

export const useFetchSurveyRewardsIntentions = (): any =>
  useQuery('surveyRewardsIntentions', () => API.get('surveyRewardsIntentions'))

export const useFetchSurveyParticipation = (): any =>
  useQuery('surveyParticipation', () => API.get('surveyParticipation'))
